import React from 'react';
import { DetailsType } from 'src/shared/types/src/lib/invoice.types'
import { getFormattedAmount, dateFormatter } from 'src/shared/utils/src';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import SuccessStatusTag from 'src/app/components/commonComponents/statusTags/SuccessStatusTag';
import WarningStatusTag from 'src/app/components/commonComponents/statusTags/WarningStatusTag';
import CustomButton from 'src/app/components/commonComponents/CustomButton';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'src/app/navigation/routes';
import CustomAmountComponent from 'src/app/components/CustomAmountComponent';

type InvoiceDetailsModalType = {
    invoiceData?: DetailsType,
    currency?: string,
    isInvoiceDetailsModal: boolean,
    toggleInvoiceDetailsModal: () => void
}

const InvoiceDetailsModal: React.FC<InvoiceDetailsModalType> = ({ invoiceData, currency, isInvoiceDetailsModal, toggleInvoiceDetailsModal }) => {

    const navigate = useNavigate()

    const onPressViewInvoice = () => {
        toggleInvoiceDetailsModal();
        navigate(AppRoutes.INVOICE_DETAILS, { state: { 
            url: invoiceData?.url, 
            downloadURL: invoiceData?.downloadPdfUrl,
            headerTitle: `Invoice${invoiceData?.txid ? `${" "}(${invoiceData?.txid})` : ''}`,
            showDownloadBtn: true,
            downloadErrorMsg: 'The invoice is not yet sent by your childcare provider. Please try again later.'
        } });
    };

    return (
        <Modal 
            isOpen={isInvoiceDetailsModal}
            toggle={toggleInvoiceDetailsModal}
            className={`custom-modal-md modal-dialog-bottom modal-dialog-bottom-style`}
            modalClassName={`modal-slide-down`}
            backdrop={"static"}
            keyboard={false}
            centered={true}
        >
            <ModalHeader toggle={toggleInvoiceDetailsModal}>Invoice Details</ModalHeader>
            <ModalBody>
                <>
                    <div className='d-flex align-items-center mg-b-15'>
                        <div className='fs-12 text-gray-300'>Invoice No:</div>
                        <div className='fs-14 text-black pd-l-10'>{invoiceData?.txid || '-'}</div>
                    </div>
                    <div className='d-flex align-items-center mg-b-15'>
                            <div className='fs-12 text-gray-300'>Amount:</div>
                            <div className='fs-14 text-black pd-l-10'>
                            {invoiceData?.amount && currency ?  <CustomAmountComponent amount={invoiceData.amount} currency={currency} /> : '-'}
                            </div>
                    </div> 
                    <div className='d-flex align-items-center mg-b-15'>
                        <div className='fs-12 text-gray-300'>From Date:</div>
                        <div className='fs-14 text-black pd-l-10'>{invoiceData?.fromDate ? dateFormatter(invoiceData?.fromDate) : '-'}</div>
                    </div>
                    <div className='d-flex align-items-center mg-b-15'>
                        <div className='fs-12 text-gray-300'>To Date:</div>
                        <div className='fs-14 text-black pd-l-10'>{invoiceData?.toDate ? dateFormatter(invoiceData?.toDate) : '-'}</div>
                    </div>
                    <div className='d-flex align-items-center mg-b-15'>
                        <div className='fs-12 text-gray-300'>Invoice Date:</div>
                        <div className='fs-14 text-black pd-l-10'>{invoiceData?.invoiceDate ? dateFormatter(invoiceData?.invoiceDate) : '-'}</div>
                    </div>
                    <div className='d-flex align-items-center mg-b-15'>
                        <div className='fs-12 text-gray-300'>Due Date:</div>
                        <div className='fs-14 text-black pd-l-10'>{invoiceData?.dueDate ? dateFormatter(invoiceData?.dueDate) : '-'}</div>
                    </div>
                    <div className='d-flex mg-b-15'>
                        <div className='fs-12 text-gray-300'>Reference:</div>
                        <div className='fs-14 text-black pd-l-10 word-break'>{invoiceData?.reference || '-'}</div>
                    </div>
                    <div className='d-flex align-items-center mg-b-15'>
                        <div className='fs-12 text-gray-300'>Status:</div>
                        <div className='pd-l-10'>
                            {invoiceData?.status === 'PAID' && <SuccessStatusTag statusString={invoiceData?.status} />}
                            {invoiceData?.status === 'PENDING PAYMENT' && <WarningStatusTag statusString={invoiceData?.status} />}
                        </div>
                    </div>
                </>
            </ModalBody>
            <ModalFooter>
                <CustomButton text="View Invoice" color="primary" onClick={onPressViewInvoice} />
            </ModalFooter>
        </Modal>
    )
};

export default InvoiceDetailsModal;